var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingStateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_900_11953)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#16A02C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6851 10.3853C9.65656 11.1433 8 11.7764 8 11.7851C8 11.8084 15.379 14.5732 15.44 14.5732C15.4981 14.5732 18.23 13.5306 18.23 13.5306C18.23 13.5306 22.88 11.8055 22.88 11.7851C22.88 11.7561 15.4923 8.9971 15.4255 9C15.3935 9 13.7108 9.62441 11.6851 10.3853Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16.9052V21.0959L11.4672 22.3941C13.3707 23.1086 14.9401 23.6923 14.9547 23.6923C14.9663 23.6923 14.975 21.8075 14.975 19.5015V15.3107L11.5108 14.0126C9.60425 13.2981 8.03488 12.7144 8.02325 12.7144C8.00872 12.7144 8 14.5992 8 16.9052ZM10.8103 19.7919L12.5124 20.396V20.8723C12.5124 21.2382 12.5037 21.3428 12.4775 21.3341C12.4572 21.3254 11.2463 20.9101 10.7551 20.7271L9.86 20.396V19.9226C9.86 19.6642 9.86872 19.4522 9.88034 19.4522C9.88906 19.4522 10.3076 19.6061 10.8103 19.7919Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.905 15.3107V19.5015C15.905 21.8075 15.9137 23.6923 15.9282 23.6923C15.9398 23.6923 17.5092 23.1086 19.4157 22.3941L22.88 21.0959V16.9052C22.88 13.5711 22.88 12.6273 22.88 12.6273L15.905 15.3107Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.8015L8.86679 11.4653V21.2939L8 20.9982V11.8015Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8801 11.7866L21.9342 11.7865V21.3684L22.8801 20.9832V11.7866Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8494 21.0819V20.102L15.4565 22.9255L8.08031 20.1176V21.0763L15.4688 23.8832L22.8494 21.0819Z",
    fill: "#FFF536"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 21,
    r: 3.4,
    fill: "#FFF536",
    stroke: "#16A02C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 18.7998V21.1998H24.5",
    stroke: "#16A02C",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_900_11953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingStateActive);
export default __webpack_public_path__ + "static/media/pending_state_active.d7fc42e7248eab9ad150d21a54a8e9bb.svg";
export { ForwardRef as ReactComponent };